import { Component, OnInit, Inject } from '@angular/core';
import { GSL, GslTeamTypes, RBTeamMember } from 'src/app/team/Models/Team';
import { SharedService } from 'src/app/core/Services/shared.service';
import { TeamService } from 'src/app/team/Services/team.service';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { ItemAddComponent, ItemForm } from 'src/app/core/Components/shared/item-add/item-add.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MemberListBoxComponent } from 'src/app/core/Components/shared/member-listbox/member-listbox.component';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { VERBIAGE } from 'src/app/config';

@Component({
    selector: 'team-gsl',
    templateUrl: './team-gsl.component.html',
    styleUrls: ['./team-gsl.component.scss']
})

export class TeamGSLComponent implements OnInit {
    GSL: GSL[];
    GslTeamTypes: GslTeamTypes[];
    Members: RBTeamMember[];

    activeTeam: number;
    activeGsl: number;

    constructor(private _shared: SharedService, private _team: TeamService, private _notify: NotificationService) {
        // Setting up page title
        this._shared.pageTitle = 'Global Service Lines';
    }

    ngOnInit() {
        // Get GSL list
        this._team.getGSL().subscribe(res => this.GSL = <GSL[]>res['result']);
    }

    // Manage GSL
    manageGSL() {
        this.GslTeamTypes = null;
        this.Members = null;
        this._shared.openModal(TeamGslManageComponent, this.GSL);
    }

    // Get team types of gslID
    async onGslSelect(gslID: number) {
        this.Members = null; this.GslTeamTypes = null; this.activeTeam = null; this.activeGsl = gslID;
        this.GslTeamTypes = <GslTeamTypes[]>await this._team.getTeamTypesByGslID(gslID);
    }

    // Get teammembers of selected team
    async onGslTeamTypeSelect(teamTypeID: number) {
        this.Members = <RBTeamMember[]>await this._team.getTeamMembersByTeamTypeID(teamTypeID);
        this.activeTeam = teamTypeID;
    }

    // Add new teamType in GSL
    addTeamTypeInGsl(gslID: number) {
        const form: ItemForm = {
            title: 'GSL Teams',
            submitText: 'Add Team',
            controls: [
                {
                    label: 'Name', name: 'teamTypeName', placeholder: 'eg. Sales, Executive or Product',
                    errorMsg: 'Please provide a team nam.'
                }
            ]
        }

        const ref: MatDialogRef<ItemAddComponent> = this._shared.openModal(ItemAddComponent, form);
        ref.afterClosed().subscribe(async res => {
            if (!res) { return; }
            // Add team type in DB
            let response  = await this._team.addTeamTypeInGSL({ teamTypeName: res.teamTypeName, gslID });
            this.GslTeamTypes.push(response.result);
        });
    }

    // Delete teamType from GSL
    deleteGslTeam(teamTypeID: number) {
        const _this = this;
        this._notify.openDialog({
            title: VERBIAGE.DELETE_GSL_TEAM_TYPE_TITLE,
            body: VERBIAGE.DELETE_GSL_TEAM_TYPE_BODY,
            handlers: [
                { color: 'warn', text: 'Confirm', type: '-raised-', action() {
                    // Delete from database
                    _this._team.deleteTeamType(teamTypeID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            let index = _this.GslTeamTypes.findIndex(x => x.teamTypeID === teamTypeID);
                            _this.GslTeamTypes.splice(index, 1);
                        }
                    });
                }}, { text: 'Cancel', type: '-raised-' }
            ]
        });
    }

    // Update GslTeamOrder
    async updateTeamTypeSequence(e: CdkDragDrop<GslTeamTypes[]>) {
        moveItemInArray(this.GslTeamTypes, e.previousIndex, e.currentIndex);
        const order = [];
        this.GslTeamTypes.forEach((t, i) => {
            order.push({ teamTypeID: t.teamTypeID, teamSequence: (i+1) });
        });

        // process result for error or success
        const result = await this._team.updateGslTeamOrder(order);
    }

    // Add new teammember to GslTeamType
    async linkMemberToGslTeamType(gslID: number) {
        const teammembers: RBTeamMember[] = await this._team.getTeamMembersOfGsl(gslID);

        // Removing already added members
        this.Members.forEach((member) => {
            let index = teammembers.findIndex(x => x.teammemberID === member.teammemberID);
            teammembers.splice(index, 1);
        });


        const ref: MatDialogRef<MemberListBoxComponent> = this._shared.openModal(MemberListBoxComponent, teammembers);
        ref.afterClosed().subscribe(members => {
            if (!members) { return; }
            members.forEach(async m => {
                // Bad practive refine your code.
                const data = { teammemberID: m.teammemberID, teamTypeID: this.activeTeam }
                let response = await this._team.linkTeamMemberOnGslTeamType(data);
                if (response['status'] === 'OK') {
                    m.teamTypeID = response['result']['teamTypeID'];
                    this .Members.push(m);
                }
            });
        });
    }

    // Remove teammember from GslTeamType
    unlinkMemberFromGslTeamType(member: RBTeamMember) {
        const _this = this;
        this._notify.openDialog({
            title: VERBIAGE.GSL_TEAM_UNLINK_TITLE,
            body: VERBIAGE.GSL_TEAM_UNLINK_BODY,
            handlers: [
                { color: 'warn', type: '-raised-', text: 'Confirm', async action() {
                    // Unlink in DB
                    const result = await _this._team.unlinkTeamMemberFromGslTeamType(member.teamTypeID, member.teammemberID);
                    if (result['status'] === 'OK') {
                        const index = _this.Members.findIndex(x => x.teammemberID === member.teammemberID);
                        _this.Members.splice(index, 1);
                    }
                }}, { type: '-raised-', text: 'Cancel' }
            ]
        })
    }

    // Update Member order
    updateMemberSequence(e: CdkDragDrop<RBTeamMember[]>) {
        moveItemInArray(this.Members, e.previousIndex, e.currentIndex);
        
        const order = [];
        this.Members.forEach((m, i) => {
            order.push({ teamTypeID: m.teamTypeID, teamSequence: (i+1), teammemberID: m.teammemberID });
        });

        this._team.updateGslTeamMembersOrder(order).subscribe(res => {
           // Process result 
        });
        
    }

    updateTeamMemberVisibility(e, member) {
        // Update member visibility in GslTeamType
        // waiting for api.
    }
}


@Component({
    selector: 'team-gsl-manage',
    templateUrl: './team-gsl-manage.component.html',
    styleUrls: ['./team-gsl.component.scss']
})

export class TeamGslManageComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public GSL: GSL[], private _notify: NotificationService,
        private _team: TeamService, private dialogRef: MatDialogRef<TeamGslManageComponent>,
        private _shared: SharedService
    ) {}

    async updateGslSequence(e) {
        moveItemInArray(this.GSL, e.previousIndex, e.currentIndex);
        const order = [];
        this.GSL.forEach((g, i) => {
            order.push({ gslID: g.gslID, gslSequence: (i+1) });
        });

        // process result for error or success
        const result = await this._team.updateGSLOrder(order);
    }

    editGSL(gsl: GSL) {
        const form: ItemForm = {
            title: 'Global Service Line',
            submitText: 'Update',
            controls: [
                {
                    label: 'GSL Name', name: 'gslName', placeholder: '', errorMsg: 'Please provide GSL name.',
                    value: gsl.gslName
                }
            ]
        }

        let ref: MatDialogRef<ItemAddComponent> = this._shared.openModal(ItemAddComponent, form);
        ref.afterClosed().subscribe(result => {
            if (!result) { return; }
            gsl.gslName = result.gslName;
            this._team.editGSL(gsl).subscribe(res => {
                // process response here.
            });
        });
    }

    deleteGSL(gslID: number) {
        const _this = this;
        this._notify.openDialog({
            color: 'warn',
            title: VERBIAGE.DELETE_GSL_TITLE,
            body: VERBIAGE.DELETE_GSL_BODY,
            handlers: [
                { color: 'warn', text: 'Confirm', type: '-raised-', action() {
                    // Delete from database
                    _this._team.deleteGSL(gslID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            let index = _this.GSL.findIndex(x => x.gslID === gslID);
                            _this.GSL.splice(index, 1);
                        }
                    });
                }}, { text: 'Cancel', type: '-raised-' }
            ]
        });
    }

    addNewGSL(form) {
        if (!form.valid) { return; }

        this._team.addGSL(form.value).subscribe(res => {
            if (res['status'] === 'OK') {
                this.GSL.push(res.GSL);
                this.dialogRef.close();
            }
        });
    }
}